import React from 'react';
import { StyleSheet } from 'react-native';
import Button from './Button';
import { KeyboardAvoidingContainerNew } from './KeyboardAvoidingContainerNew';
export const KeyboardAvoidingButton = ({ flexContainer, withFrame = true, ...props }) => (<KeyboardAvoidingContainerNew isInIOS13Modal={props.isInIOS13Modal} isInTab={props.isInTab} flexContainer={flexContainer} withFrame={withFrame} withMarginHorizontal={false} sticky>
    <Button {...props} floating containerStyle={[styles.button, !withFrame && styles.buttonWithoutFrame]}/>
  </KeyboardAvoidingContainerNew>);
const styles = StyleSheet.create({
    button: {
        bottom: 0,
    },
    buttonWithoutFrame: {
        marginHorizontal: 0,
    },
});
